import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { dictionaries } from "./translations.js";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = "ltr";
  }, [lang]);

  const t = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.en;
    const getter = (path) => path.split(".").reduce((o, k) => (o ? o[k] : undefined), dict);
    return getter;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() { return useContext(LanguageContext); }
export function useT() { return useContext(LanguageContext).t; }
